<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<h1 class="ack">List of maps</h1>
<p class="nonindentj"><a class="hlink" href="#/OEBPS/fm#mapvii">Europe under Nazi rule</a></p>
<p class="nonindentj"><a class="hlink" href="#/OEBPS/c01#map26-1">The four death camps</a></p>
<p class="nonindentj"><a class="hlink" href="#/OEBPS/c04#map41-1">The Bund Report of May 1942</a></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c08#map79-1" title="Link target outside of Sample">The ‘Teheran children’</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c10#map89-1" title="Link target outside of Sample">The first eye-witnesses arrive</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c21#map191-1" title="Link target outside of Sample">First flight over Auschwitz</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c21#map193-1" title="Link target outside of Sample">The Auschwitz-Birkenau-Monowitz region</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c21#map195-1" title="Link target outside of Sample">Birkenau</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c21#map197-1" title="Link target outside of Sample">The escapees reach Slovakia</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c24#map213-1" title="Link target outside of Sample">The Brand mission</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c24#map221-1" title="Link target outside of Sample">Operation Frantic, June 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c26#map247-1" title="Link target outside of Sample">Railway routes and the bombing appeal</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c26#map252-1" title="Link target outside of Sample">The truth about Auschwitz reaches the West</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c29#map283-1" title="Link target outside of Sample">Allied bomber raids, July 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c31#map302-1" title="Link target outside of Sample">Operation Frantic, August 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c31#map306-1" title="Link target outside of Sample">Allied bomber raids, August 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c31#map307-1" title="Link target outside of Sample">Allied bomber targets in the Auschwitz region</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c32#map316-1" title="Link target outside of Sample">An air reconnaissance sortie over Auschwitz, 16 September 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c32#map318-1" title="Link target outside of Sample">Allied bombing targets during September 1944</span></p>
<p class="nonindentj"><span class="hlink" href="#/OEBPS/c32#map323-1" title="Link target outside of Sample">Allied airborne aid to Poland, September 1944</span></p>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// limap.vue?0cb42f86